<div class="cookies-background">

  Táto stránka používa súbory cookies a ďalšie sieťové identifikátory vrátane informačnej
  povinnosti, aby sme zlepšili Vašu používateľskú skúsenosť. My a naši partneri máme k týmto
  údajom prístup, alebo ich ukladáme. Tieto údaje používame najmä na anonymnú analýzu
  návštevnosti a zlepšovanie našich stránok.

  <br>

  Viac informácií nájdete na stránke <a class="text-white text-underline" routerLink="/cookies-rules/rules">Pravidlá používania cookies</a>.

  <br>

  Kliknutím na „POVOLIŤ VŠETKO“ súhlasíte s uvedeným textom v plnom rozsahu. Viac informácií
  pri zakliknutí „UPRAVIŤ“.

  <div class="row">

    <div class="col-6 text-right">

      <button type="submit"
              (click)="openCookiesEditModal()"
              class="btn btn-primary text-white">
        Upraviť
      </button>

    </div>

    <div class="col-6 text-left">

      <button type="submit"
              (click)="enableAll()"
              class="btn btn-primary text-white">
        Povoliť všetko
      </button>

    </div>

  </div>

</div>
